import { FunctionComponent } from "react";
import { observer } from "mobx-react-lite";

import { Sidebar } from "primereact/sidebar";

import { useStore } from "../../../../stores/StoreContext";
import { CompanyLogo, FeatureList } from "../../../Shared/Components";
import { SidebarFeatureAreaItem } from "../SidebarFeatureAreaItem/SidebarFeatureAreaItem";

import "./OverlaySidebar.scss";

const RawOverlaySidebar: FunctionComponent = () => {
  const { navigationStore, sidebarStore } = useStore();

  return (
    <Sidebar
      className="sidebar-overlay"
      visible={sidebarStore.isOverlaySidebarVisible}
      header={
        <div style={{ maxWidth: "60%" }}>
          <CompanyLogo />
        </div>
      }
      onHide={() => sidebarStore.setOverlaySidebarVisible(false)}
    >
      <div className="sidebar-overlay-content-container">
        <div className="sidebar-feature-menu">
          <FeatureList collapsed={!!sidebarStore.isCollapsed && !sidebarStore.isOverlaySidebarVisible} />
        </div>

        {!!navigationStore.currentActiveMenuItem?.sidebarFeatureAreas && (
          <div className="sidebar-feature-content">
            {navigationStore.currentActiveMenuItem.sidebarFeatureAreas.map(sidebarFeatureArea => (
              <SidebarFeatureAreaItem key={sidebarFeatureArea.id} config={sidebarFeatureArea} />
            ))}
          </div>
        )}

        {!!navigationStore.currentActiveMenuItem?.sidebarAddNewButton && (
          <div className="sidebar-new-button-container">
            {navigationStore.currentActiveMenuItem.sidebarAddNewButton()}
          </div>
        )}
      </div>
    </Sidebar>
  );
};

export const OverlaySidebar = observer(RawOverlaySidebar);
